export default __webpack_public_path__ + "static/media/next.c805b00f.png";